import type { HTMLAttributes, ReactNode } from "react";
import styles from "./Callout.module.css";
import { cx } from "../cx";
import { IconCheckmarkLine, IconReportLine } from "../icons/Icon";

export type CalloutTone = "neutral" | "informative" | "positive" | "warning" | "critical";

export type CalloutProps = HTMLAttributes<HTMLDivElement> & {
  tone?: CalloutTone;
  title: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
};

/** SEED Callout (Figma 62:1005). */
export function Callout({ tone = "neutral", title, description, icon, className, ...rest }: CalloutProps) {
  const DefaultIcon = tone === "positive" ? IconCheckmarkLine : IconReportLine;
  return (
    <div role={tone === "critical" ? "alert" : "status"} className={cx(styles.root, styles[tone], className)} {...rest}>
      <span className={styles.icon}>{icon ?? <DefaultIcon size={18} />}</span>
      <div className={styles.texts}>
        <p className={styles.title}>{title}</p>
        {description && <p className={styles.description}>{description}</p>}
      </div>
    </div>
  );
}
